import axios from 'axios';
import Cookies from 'js-cookie';

const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from localStorage or cookies
const getAuthToken = () => {
  return (
    localStorage.getItem('authToken') ||
    Cookies.get('jwtToken') ||
    null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
});

// Clinic Hours service methods
export const clinicHoursService = {
  // Get clinic hours
  getClinicHours: async () => {
    try {
      console.log('[clinicHoursService] GET /clinic/hours', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/clinic/hours`
      });
      const response = await apiClient.get('/clinic/hours');
      return response.data;
    } catch (error) {
      console.error('Error fetching clinic hours:', error);
      throw error;
    }
  },

  // Get formatted clinic hours
  getFormattedClinicHours: async () => {
    try {
      console.log('[clinicHoursService] GET /clinic/hours/formatted', {
        url: `${API_BASE_URL}/clinic/hours/formatted`
      });
      const response = await axios.get(`${API_BASE_URL}/clinic/hours/formatted`);
      return response.data;
    } catch (error) {
      console.error('Error fetching formatted clinic hours:', error);
      throw error;
    }
  },

  // Update clinic hours
  updateClinicHours: async (hoursData) => {
    try {
      console.log('[clinicHoursService] PUT /clinic/hours', {
        token: getAuthToken(),
        url: `${API_BASE_URL}/clinic/hours`,
        data: hoursData
      });
      
      const response = await axios.put(`${API_BASE_URL}/clinic/hours`, hoursData, {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating clinic hours:', error);
      throw error;
    }
  },
};
